import { render, staticRenderFns } from "./Transactions.vue?vue&type=template&id=daf2568a&scoped=true"
import script from "./Transactions.vue?vue&type=script&lang=js"
export * from "./Transactions.vue?vue&type=script&lang=js"
import style0 from "./Transactions.vue?vue&type=style&index=0&id=daf2568a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf2568a",
  null
  
)

export default component.exports